import { Grid, Paper } from '@mui/material';
import classNames from 'classnames';
import { BuyerProtectionModal } from 'components/BuyerProtectionModal/BuyerProtectionModal';
import { useCheckoutInteraction } from 'contexts/CheckoutInteractionContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  className?: string;
  buyerSideFeesPercentage?: number;
  buyerSideFeesFixed?: number;
  align?: 'left' | 'center';
};

const PaymentShieldHighlighted = (props: Props) => {
  const { t } = useTranslation();
  const trackCheckoutInteraction = useCheckoutInteraction();
  const [isBuyerProtectionModalOpen, setBuyerProtectionModalOpen] = useState(false);

  const { className, buyerSideFeesPercentage, buyerSideFeesFixed, align = 'center' } = props;

  // fires checkout_interaction only when this shared banner is rendered inside a checkout (the
  // context default is a no-op elsewhere), so buyer-protection info opens are captured in
  // checkout. DEV-2120: the banner and summary buttons carry distinct values so each is
  // identifiable by value alone, like every other info_toggle.
  const openBuyerProtectionModal = () => {
    trackCheckoutInteraction({
      element: 'info_toggle',
      action: 'tap',
      value: 'buyer_protection_banner',
      value_source: 'first_party',
    });
    setBuyerProtectionModalOpen(true);
  };

  return (
    <>
      <Grid className={classNames('payment-shield-highlighted', align, className)} container>
        <Paper elevation={0} className="shield-paper">
          <Grid container className="shield-content" onClick={openBuyerProtectionModal}>
            <img src="/icons/icn-shield.svg" alt="" className="shield-icon" />
            <div className="shield-text">
              <>
                <div className="shield-text-title">
                  {t('components.page-product.product-details.shield.buyer-protection-highlighted.title')}&nbsp;
                </div>
                <div>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('components.page-product.product-details.shield.buyer-protection-highlighted.text'),
                    }}
                  />
                  &nbsp;
                </div>
              </>
            </div>
          </Grid>
        </Paper>
      </Grid>
      <BuyerProtectionModal
        isOpen={isBuyerProtectionModalOpen}
        setOpen={setBuyerProtectionModalOpen}
        tooltipButtonClassName="hidden"
        buyerSideFeesPercentage={buyerSideFeesPercentage}
        buyerSideFeesFixed={buyerSideFeesFixed}
      />
    </>
  );
};

export default PaymentShieldHighlighted;
